// extracted by mini-css-extract-plugin
module.exports = {"body_loading":"PageLoader_body_loading__Bo3Rf","none":"PageLoader_none__EEG6B","img_wrapper":"PageLoader_img_wrapper__7nlmD","loader":"PageLoader_loader__U_F1B"};